import { Environment } from './environment.d'

export const environment: Environment = {
  production: process.env.APP_ENV === 'prod',
  environment: process.env.APP_ENV,
  essent: {
    url: process.env.ESSENT_URL,
    apiKey: process.env.ESSENT_API_KEY,
    lenderIdentifier: process.env.ESSENT_LENDER_IDENTIFIER,
    transactionIdentifier: process.env.ESSENT_TRANSACTION_IDENTIFIER,
  },
  errorLog: {
    accessKeyId: process.env.ERROR_LOGGING_BUCKET_ACCESS_KEY_ID,
    secretAccessKey: process.env.ERROR_LOGGING_BUCKET_SECRET_KEY,
    region: 'us-east-1',
    bucketName: process.env.ERROR_LOGGING_BUCKET_NAME,
  },
  productName: process.env.PRODUCT_NAME,
  uiBaseUrl: process.env.UI_BASE_URL,
  apiBaseUrl: process.env.API_BASE_URL,
  aiApiBaseUrl: process.env.AI_API_BASE_URL, // Ngrok url if testing the ringcentral webhooks
  admin: {
    authToken: process.env.ADMIN_AUTH_TOKEN,
    uiUrl: process.env.ADMIN_UI_URL,
  },
  adminApi: {
    baseUrl: process.env.ADMIN_API_BASE_URL,
    token: process.env.ADMIN_AUTH_TOKEN,
  },
  jobsApi: {
    apiInternalUrl:
      process.env.JOBS_API_INTERNAL_URL || 'http://localhost:4401',
    domain: process.env.JOBS_API_AUTH0_DOMAIN,
    clientId: process.env.JOBS_API_AUTH0_CLIENT_ID,
    clientSecret: process.env.JOBS_API_AUTH0_CLIENT_SECRET,
    audience: process.env.JOBS_API_AUTH0_AUDIENCE,
  },
  auth0: {
    domain: process.env.AUTH0_DOMAIN,
    apiAudience: process.env.AUTH0_API_AUDIENCE,
    clientId: process.env.AUTH0_CLIENT_ID_QUESTIONNAIRE,
    secret: process.env.AUTH0_CLIENT_SECRET_QUESTIONNAIRE,
    borrowerPortalClientId: process.env.AUTH0_CLIENT_ID_BORROWER_PORTAL_API,
    borrowerPortalSecret: process.env.AUTH0_CLIENT_SECRET_BORROWER_PORTAL_API,
    // There can be multiple connection configured in a given Auth0 tenant. Add
    // connections here as they are added (i.e. a social identity provider)
    dbConnections: {
      userPass: process.env.AUTH0_USER_PASS_DB_CONNECTION,
    },
    audience: process.env.AUTH0_AUDIENCE,
  },
  adminApiAuth0: {
    domain: process.env.ADMIN_API_AUTH0_DOMAIN,
    clientId: process.env.ADMIN_API_AUTH0_CLIENT_ID,
    clientSecret: process.env.ADMIN_API_AUTH0_CLIENT_SECRET,
    audience: process.env.ADMIN_API_AUTH0_AUDIENCE,
  },
  documentExtract: {
    accessKeyId: process.env.AWS_ACCESS_KEY_ID_LE_COMPARISON,
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY_LE_COMPARISON,
    region: 'us-east-1',
    bucketName: process.env.BUCKET_NAME_LE_COMPARISON,
    bedrockAccessKey: process.env.BEDROCK_ACCESS_KEY,
    bedrockSecretKey: process.env.BEDROCK_SECRET_KEY,
    openaiApiKey: process.env.OPENAI_API_KEY,
    loanAssistantAgentId: process.env.BEDROCK_LOAN_ASSISTANT_AGENT_ID,
    loanAssistantAgentAliasId:
      process.env.BEDROCK_LOAN_ASSISTANT_AGENT_ALIAS_ID,
    azureOpenAIApiKey: process.env.AZURE_OPENAI_API_KEY,
    azureOpenAIEndpoint: process.env.AZURE_OPENAI_ENDPOINT,
    azureOpenAIDeploymentId: process.env.AZURE_OPENAI_DEPLOYMENT_ID || 'o3',
    azureOpenAIApiVersion:
      process.env.AZURE_OPENAI_API_VERSION || '2024-12-01-preview',
    sqsQueueUrl: process.env.DOCUMENT_EXTRACTION_SQS_QUEUE_URL || '',
    bedrockRetry: {
      maxAttempts: parseInt(process.env.AI_BEDROCK_MAX_RETRIES || '10', 10),
      baseDelayMs: parseInt(process.env.AI_BEDROCK_BASE_DELAY_MS || '2000', 10),
      maxDelayMs: parseInt(process.env.AI_BEDROCK_MAX_DELAY_MS || '30000', 10),
      retryOnRelatedRateLimit:
        process.env.AI_BEDROCK_RETRY_ON_RELATED_RATE_LIMIT === 'true',
    },
  },
  google: {
    project:
      process.env.GOOGLE_CLOUD_PROJECT || process.env.GOOGLE_VERTEX_PROJECT,
    location:
      process.env.GOOGLE_CLOUD_LOCATION ||
      process.env.GOOGLE_VERTEX_LOCATION ||
      'global',
    useVertexAi: process.env.GOOGLE_GENAI_USE_VERTEXAI === 'true',
    authorizedUserCredentials: {
      clientId: process.env.GOOGLE_AUTH_CLIENT_ID,
      clientSecret: process.env.GOOGLE_AUTH_CLIENT_SECRET,
      refreshToken: process.env.GOOGLE_AUTH_REFRESH_TOKEN,
      quotaProjectId:
        process.env.GOOGLE_CLOUD_QUOTA_PROJECT ||
        process.env.GOOGLE_AUTH_QUOTA_PROJECT,
      universeDomain: process.env.GOOGLE_AUTH_UNIVERSE_DOMAIN,
    },
  },
  calcService: {
    baseUrl: process.env.CALCULATOR_SERVICE_BASE_URL,
  },
  certifiedCredit: {
    apiUrl:
      process.env.CERTIFIED_CREDIT_API_URL ||
      'https://demo.mortgagecreditlink.com/inetapi/request_products.aspx',
    interfaceIdentifier:
      process.env.CERTIFIED_CREDIT_INTERFACE_IDENTIFIER ||
      'SmartAPITestingIdentifier',
    username: process.env.CERTIFIED_CREDIT_USERNAME,
    password: process.env.CERTIFIED_CREDIT_PASSWORD,
    prequalUsername: process.env.CERTIFIED_CREDIT_PREQUAL_USERNAME,
    prequalPassword: process.env.CERTIFIED_CREDIT_PREQUAL_PASSWORD,
  },
  coreLogicAVM: {
    username: process.env.CORELOGIC_AVM_USERNAME,
    password: process.env.CORELOGIC_AVM_PASSWORD,
    baseUrl: process.env.CORELOGIC_AVM_URL,
  },
  coreLogicCreditReport: {
    accountId: process.env.CORELOGIC_CREDIT_REPORT_ACCOUNT_ID,
    accountPassword: process.env.CORELOGIC_CREDIT_REPORT_ACCOUNT_PASSWORD,
    baseUrl: process.env.CORELOGIC_CREDIT_REPORT_URL,
    // In some cases we need to hit the production env
    // mainly to allow reissuing to work in Encompass on test
    baseUrlProd: process.env.CORELOGIC_CREDIT_REPORT_URL_PROD,
    accountIdProd: process.env.CORELOGIC_CREDIT_REPORT_ACCOUNT_ID_PROD,
    accountPasswordProd:
      process.env.CORELOGIC_CREDIT_REPORT_ACCOUNT_PASSWORD_PROD,
    pfxPath: process.env.CORELOGIC_CREDIT_REPORT_PFX_PATH,
    pfxPassPhrase: process.env.CORELOGIC_CREDIT_REPORT_PFX_PASSPHRASE,
  },
  ice: {
    url: process.env.ICE_URL || 'undefined-url',
    username: process.env.ICE_USERNAME || 'undefined-username',
    password: process.env.ICE_PASSWORD || 'undefined-password',
  },
  make: {
    baseUrl: 'https://ingest.make.rvapps.io',
    writeKey: process.env.MAKE_WRITEKEY,
    sourceUid: process.env.MAKE_SOURCE_UID,
  },
  mq: {
    baseUrl: process.env.MQ_API_BASE_URL,
    lockUrl: process.env.MQ_API_LOCK_URL,
    apiKey: process.env.MQ_API_API_KEY,
    lockApiKey: process.env.MQ_API_LOCK_API_KEY,
    advertiserId: process.env.MQ_ADVERTISER_ID,
    lockAdvertiserId: process.env.MQ_LOCK_ADVERTISER_ID,
    qaAdvertiserId: process.env.MQ_QA_ADVERTISER_ID,
  },
  elloAssistantDebug: {
    enabled: process.env.ELLO_ASSISTANT_DEBUG_MODE === 'true',
    useRedisStorage: process.env.ELLO_ASSISTANT_USE_REDIS_STORAGE === 'true',
    redisTtlSeconds: parseInt(
      process.env.ELLO_ASSISTANT_REDIS_TTL_SECONDS || '604800',
      10
    ), // Default to 7 days
  },
  factualData: {
    hardUsername: process.env.FACTUAL_DATA_CREDIT_REPORT_ACCOUNT_USERNAME,
    hardPassword: process.env.FACTUAL_DATA_CREDIT_REPORT_ACCOUNT_PASSWORD,
    softUsername:
      process.env.FACTUAL_DATA_CREDIT_REPORT_SOFT_PULL_ACCOUNT_USERNAME,
    softPassword:
      process.env.FACTUAL_DATA_CREDIT_REPORT_SOFT_PULL_ACCOUNT_PASSWORD,
    fannieMaeCreditProviderCode:
      process.env.FACTUAL_DATA_FANNIE_MAE_CREDIT_ACCOUNT_ID,
    freddieMacCreditProviderCode:
      process.env.FACTUAL_DATA_FREDDIE_MAC_CREDIT_ACCOUNT_ID,
  },
  rvmnConfig: {
    host: process.env.RVMN_SFTP_HOST || 'undefined-host',
    port: 22,
    username: process.env.RVMN_SFTP_USERNAME || 'undefined-username',
    password: process.env.RVMN_SFTP_PASSWORD || 'undefined-password',
    directory: '/',
    rankedDirectory: '/conversion_events_filler_clicks/',
    clickedLeadsDirectory: '/down_funnel_events/',
    postedLeadsDirectory: '/down_funnel_filler_clicks/',
    bucketName: process.env.RVMN_BACKUP_S3_BUCKET,
    accessKeyId: process.env.RVMN_BACKUP_S3_ACCESS_KEY_ID,
    secretAccessKey: process.env.RVMN_BACKUP_S3_SECRET_ACCESS_KEY,
    region: process.env.REGION,
  },
  ringCentral: {
    url: process.env.RING_CENTRAL_URL,
    basicToken: process.env.RING_CENTRAL_BASIC_TOKEN,
    jwtToken: process.env.RING_CENTRAL_JWT_TOKEN,
    username: process.env.RING_CENTRAL_USERNAME,
    password: process.env.RING_CENTRAL_PASSWORD,
    extensionNumber: process.env.RING_CENTRAL_EXTENSION,
    clientId: process.env.RING_CENTRAL_CLIENT_ID,
    clientSecret: process.env.RING_CENTRAL_CLIENT_SECRET,
    recordingsRegion: process.env.REGION,
    recordingsS3Bucket:
      process.env.RC_RECORDINGS_S3_BUCKET || 'undefined-bucket',
    recordingsAccessKeyId: process.env.RC_RECORDINGS_ACCESS_KEY_ID || '',
    recordingsSecretAccessKey:
      process.env.RC_RECORDINGS_SECRET_ACCESS_KEY || '',
  },
  amazonTranscribe: {
    region: process.env.AMAZON_TRANSCRIBE_REGION || 'us-east-1',
    accessKeyId: process.env.AMAZON_TRANSCRIBE_ACCESS_KEY_ID || '',
    secretAccessKey: process.env.AMAZON_TRANSCRIBE_SECRET_ACCESS_KEY || '',
    outputBucketName:
      process.env.AMAZON_TRANSCRIBE_OUTPUT_BUCKET_NAME || 'undefined-bucket',
    serviceRoleArn: process.env.AMAZON_TRANSCRIBE_SERVICE_ROLE_ARN || '',
  },
  robinhood: {
    apiUrl: process.env.ROBINHOOD_API_URL || '',
    cryptoToken: process.env.ROBINHOOD_CRYPTO_TOKEN || '',
    clientId: process.env.ROBINHOOD_CLIENT_ID || '',
    clientSecret: process.env.ROBINHOOD_CLIENT_SECRET || '',
  },
  rollbar: {
    enabled: process.env.ROLLBAR_ENABLED,
    token: process.env.ROLLBAR_TOKEN_API,
  },
  slack: {
    url: 'https://hooks.slack.com',
    alfieTechWebhookRoute: process.env.SLACK_ALFIE_TECH_WEBHOOK_ROUTE,
    alfieReportingWebhookRoute: process.env.SLACK_ALFIE_REPORTING_WEBHOOK_ROUTE,
    elloTechAlertWebhookRoute: process.env.SLACK_ELLO_TECH_WEBHOOK_ROUTE,
    floatWebhookRoute: process.env.SLACK_FLOAT_WEBHOOK_ROUTE,
    fnmaApiAlertWebhookRoute: process.env.SLACK_FNMA_API_ALERT_WEBHOOK_ROUTE,
    homeEquityLeadWebhookRoute:
      process.env.SLACK_HOME_EQUITY_LEAD_WEBHOOK_ROUTE,
    lockWebhookRoute: process.env.SLACK_LOCK_WEBHOOK_ROUTE,
    lockCutoffWebhookRoute: process.env.SLACK_LOCK_CUTOFF_WEBHOOK_ROUTE,
    ntlWebhookRoute: process.env.SLACK_NTL_WEBHOOK_ROUTE,
    leadWebhookRoute: process.env.SLACK_LEAD_WEBHOOK_ROUTE,
    vepaWorkflowTriggerRoute: process.env.SLACK_VEPA_WORKFLOW_TRIGGER_ROUTE,
    vepaQueueAlertRoute: process.env.SLACK_VEPA_QUEUE_ALERT_ROUTE,
    processorNotificationsWebhookRoute:
      process.env.SLACK_PROCESSOR_NOTIFICATIONS_WEBHOOK_ROUTE,
    cicRequestNotification:
      process.env.SLACK_CIC_REQUEST_NOTIFICATIONS_WEBHOOK_ROUTE,
    loNotificationsWebhookRoute:
      process.env.SLACK_LO_NOTIFICATIONS_WEBHOOK_ROUTE,
    nmlsReportWebhookRoute: process.env.NMLS_REPORT_NOTIFICATION_BOT,
    encompassErrorsWebhookRoute:
      process.env.SLACK_ENCOMPASS_ERRORS_WEBHOOK_ROUTE,
    suspensionNotificationWebhookRoute:
      process.env.SLACK_SUSPENSION_NOTIFICATIONS_WEBHOOK_ROUTE,
    verificationReportAlertWebhookRoute:
      process.env.SLACK_VERIFICATION_REPORT_WEBHOOK_ROUTE,
    doesNotQualifyNotification:
      process.env.SLACK_DOES_NOT_QUALIFY_NOTIFICATION_WEBHOOK_ROUTE,
    aiFeedbackWebhookRoute: process.env.SLACK_AI_FEEDBACK_WEBHOOK_ROUTE,
    sagentSlackUserId: process.env.SAGENT_SLACK_USER_ID,
    postMessageRoute: process.env.SLACK_POST_MESSAGE_ROUTE,
    shlcLeadBotToken: process.env.SLACK_SHLC_LEAD_BOT_TOKEN,
    patrickShareBotToken: process.env.SLACK_PATRICK_SHARE_BOT_TOKEN,
    loanOfficerAssistantBotToken:
      process.env.LOAN_OFFICER_ASSISTANT_SLACK_BOT_TOKEN,
    lookupUserRoute: process.env.SLACK_LOOKUP_USER_ROUTE,
    unassignedLeadWebhookRoute:
      process.env.SLACK_UNASSIGNED_LEADS_WEBHOOK_ROUTE,
    phoenixAssignedLeadsWebhookRoute:
      process.env.SLACK_PHOENIX_LEADS_WEBHOOK_ROUTE,
  },
  sns: {
    accessKeyId: process.env.VELOCIFY_SNS_ACCESS_KEY,
    secretAccessKey: process.env.VELOCIFY_SNS_SECRET_ACCESS_KEY,
    region: process.env.REGION,
  },
  storyBlok: {
    // Dev tool - Set baseUrl to null to fall back to your local questionSet.ts
    // baseUrl: null,
    baseUrl: 'https://api.storyblok.com',
    token: process.env.STORYBLOK_TOKEN,
    version: process.env.STORYBLOK_VERSION,
  },
  velocify: {
    url: process.env.VELOCIFY_URL,
    username: process.env.VELOCIFY_USERNAME,
    password: process.env.VELOCIFY_PASSWORD,
  },
  vgsOutboundProxy: {
    host: process.env.VGS_OUTBOUND_PROXY_HOST,
    username: process.env.VGS_OUTBOUND_PROXY_USERNAME,
    password: process.env.VGS_OUTBOUND_PROXY_PASSWORD,
    cert: process.env.VGS_OUTBOUND_PROXY_CERT,
  },
  googleMaps: {
    url: 'https://maps.googleapis.com',
    apiKey: process.env.GOOGLE_MAPS_API_KEY,
  },
  googleStreetView: {
    url: 'https://maps.googleapis.com',
    apiKey: process.env.GOOGLE_STREET_VIEW_API_KEY,
    secret: process.env.GOOGLE_STREET_VIEW_SECRET,
  },
  googleAddressValidation: {
    baseUrl: process.env.GOOGLE_ADDRESS_VALIDATION_BASE_URL,
    apiKey: process.env.GOOGLE_ADDRESS_VALIDATION_API_KEY,
  },
  iterable: {
    baseUrl: process.env.ITERABLE_BASE_URL,
    apiKey: process.env.ITERABLE_API_KEY,
    webhookSecret: process.env.ITERABLE_WEBHOOK_SECRET,
  },
  botsplash: {
    baseUrl: process.env.BOTSPLASH_API_BASE_URL,
    // Outbound (Sage -> Botsplash) API key. Inbound requests (Botsplash -> Sage)
    // authenticate with the separate BOTSPLASH_SAGE_API_KEY (see apps/api).
    apiKey: process.env.BOTSPLASH_API_KEY,
    // Read-only Conversation Entries API key, distinct from the outbound apiKey.
    conversationApiKey: process.env.BOTSPLASH_CONVERSATION_API_KEY,
    crmBaseUrl: process.env.BOTSPLASH_CRM_BASE_URL,
    defaultListener: process.env.BOTSPLASH_DEFAULT_LISTENER,
  },
  redis: {
    host: process.env.REDIS_HOST,
  },
  retool: {
    baseUrl: process.env.RETOOL_URL,
    bearerToken: process.env.RETOOL_BEARER_TOKEN,
  },
  documentStore: {
    bucketName: process.env.BP_DOCUMENT_STORE_BUCKET,
    accessKeyId: process.env.BP_DOCUMENT_STORE_ACCESS_KEY_ID,
    secretAccessKey: process.env.BP_DOCUMENT_STORE_SECRET_ACCESS_KEY,
    region: process.env.REGION,
  },
  generatedDocumentStore: {
    bucketName: process.env.GENERATED_DOCUMENT_BUCKET,
    accessKeyId: process.env.GENERATED_DOCUMENT_ACCESS_KEY_ID,
    secretAccessKey: process.env.GENERATED_DOCUMENT_SECRET_ACCESS_KEY,
    region: process.env.REGION,
  },
  internalDocumentsStore: {
    bucketName: process.env.INTERNAL_DOCUMENTS_BUCKET,
    accessKeyId: process.env.INTERNAL_DOCUMENTS_BUCKET_ACCESS_KEY_ID,
    secretAccessKey: process.env.INTERNAL_DOCUMENTS_BUCKET_SECRET_KEY,
    region: process.env.REGION,
  },
  sagentDocumentsStore: {
    // Access is via the admin-api ECS task role (no static keys); the S3 helper
    // falls back to the task role when accessKeyId/secretAccessKey are absent.
    bucketName: process.env.SAGENT_DOCUMENTS_BUCKET,
    region: process.env.REGION,
    // Per-@sagent-workspace override buckets for the Patrick Workspace target
    // selector; the base bucketName above serves qa + prod. Only the qa admin-api
    // receives these (it serves qa/qa-b/qa-c); prod leaves them unset. Region and
    // credentials come from the base config — only the physical bucket differs.
    targets: {
      'qa-b': { bucketName: process.env.SAGENT_DOCUMENTS_BUCKET_QA_B },
      'qa-c': { bucketName: process.env.SAGENT_DOCUMENTS_BUCKET_QA_C },
    },
  },
  // Patrick artifacts registered as attachments rows; ECS task role, no static keys.
  patrickUploadsStore: {
    bucketName: process.env.PATRICK_UPLOADS_S3_BUCKET,
    region: process.env.REGION,
  },
  encompass: {
    username: process.env.ENCOMPASS_USERNAME,
    password: process.env.ENCOMPASS_PASSWORD,
    clientId: process.env.ENCOMPASS_CLIENT_ID,
    clientSecret: process.env.ENCOMPASS_CLIENT_SECRET,
    apiUrl: process.env.ENCOMPASS_API_URL,
    webhookSigningKey: process.env.ENCOMPASS_SIGNING_KEY,
    loanFolder: process.env.ENCOMPASS_LOAN_FOLDER,
    templatePath: process.env.ENCOMPASS_TEMPLATE_PATH,
  },
  encompassSdk: {
    apiUrl: process.env.ENCOMPASS_SDK_API_URL,
    apiUsername: process.env.ENCOMPASS_SDK_API_USER,
    apiPassword: process.env.ENCOMPASS_SDK_API_PASSWORD,
  },
  encompassLoanChanges: {
    region: process.env.REGION,
    bucket: process.env.ENCOMPASS_LOAN_CHANGES_BUCKET,
    bucketAccessKeyId: process.env.ENCOMPASS_LOAN_CHANGES_BUCKET_ACCESS_KEY_ID,
    bucketSecretAccessKey: process.env.ENCOMPASS_LOAN_CHANGES_BUCKET_SECRET_KEY,
  },
  docusign: {
    baseUrl: process.env.DOCUSIGN_BASE_URL,
    oAuthUrl: process.env.DOCUSIGN_OAUTH_URL,
    clientId: process.env.DOCUSIGN_CLIENT_ID,
    userId: process.env.DOCUSIGN_USER_ID,
    base64PrivateKey: process.env.DOCUSIGN_PRIVATE_KEY_BASE64,
    apiAccountId: process.env.DOCUSIGN_API_ACCOUNT_ID,
    webhookSigningKey: process.env.DOCUSIGN_SIGNING_KEY,
  },
  docutech: {
    clientId: process.env.DOCUTECH_CLIENT_ID || '',
    identityProvider:
      process.env.DOCUTECH_IDENTITY_PROVIDER ||
      'https://borrower-portal.qa.sagehomeloans.com',
    base64PrivateKey: process.env.DOCUTECH_PRIVATE_KEY_BASE64 || '',
    tokenEndpoint:
      process.env.DOCUTECH_TOKEN_ENDPOINT ||
      'https://stage.auth.stg.docutech.app/connect/token',
    audience:
      process.env.DOCUTECH_AUDIENCE || 'https://stage.auth.stg.docutech.app',
  },
  elloSync: {
    accessKeyId: process.env.ELLO_SYNC_ACCESS_KEY_ID,
    secretAccessKey: process.env.ELLO_SYNC_SECRET_ACCESS_KEY,
    region: process.env.REGION,
    queueUrl: process.env.ELLO_SYNC_PROCESSOR_QUEUE_URL,
    deadLetterUrl: process.env.ELLO_SYNC_PROCESSOR_DEAD_LETTER_URL,
  },
  encompassWebhook: {
    accessKeyId: process.env.ENCOMPASS_WEBHOOK_ACCESS_KEY_ID,
    secretAccessKey: process.env.ENCOMPASS_WEBHOOK_SECRET_ACCESS_KEY,
    region: process.env.REGION,
    queueUrl: process.env.ENCOMPASS_WEBHOOK_PROCESSOR_QUEUE_URL,
    deadLetterUrl: process.env.ENCOMPASS_WEBHOOK_PROCESSOR_DEAD_LETTER_URL,
  },
  monarch: {
    url: 'https://monarch.cohesionapps.com/api',
    clientToken: process.env.MONARCH_TOKEN,
    sourceId: process.env.MONARCH_API_SOURCE_ID,
    loTemplateRuleId: process.env.MONARCH_LO_TEMPLATE_RULE_ID,
  },
  fannieMae: {
    partnerId: '10000034',
    institutionId: process.env.FANNIE_MAE_INSTITUTION_ID,
    username: process.env.FANNIE_MAE_AUS_USERNAME,
    password: process.env.FANNIE_MAE_AUS_PASSWORD,
    loanSellerId: process.env.FANNIE_MAE_LOAN_SELLER_ID,
  },
  silk: {
    url: 'https://orders.silktitleco.com',
    sageProductId: 178341,
    apiKey: process.env.SILK_API_KEY,
  },
  nexuss: {
    url: 'https://clients.unisourcejv.com',
    username: 'sageu',
    password: process.env.NEXUSS_PASSWORD,
    sagePartnerId: 534342,
  },
  finicity: {
    apiUrl: 'https://api.finicity.com',
    appKey: process.env.FINICITY_APP_KEY,
    partnerId: process.env.FINICITY_PARTNER_ID,
    partnerSecret: process.env.FINICITY_PARTNER_SECRET,
    webhookUrl: process.env.FINICITY_WEBHOOK_URL,
  },
  emailProcessor: {
    region: process.env.REGION,
    queueUrl: process.env.EMAIL_PROCESSOR_QUEUE_URL,
    subscriptionClientState: process.env.SUBSCRIPTION_CLIENT_STATE,
    tenantId: process.env.EMAIL_PROCESSOR_TENANT_ID,
    clientId: process.env.EMAIL_PROCESSOR_CLIENT_ID,
    // To refresh, visit:
    //  https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Credentials/appId/3e1fa055-e6e3-4cb9-9ccd-43fec78aa33f
    // Click, "New client secret", copy the Value and paste it into AWS Parameter Store & Keeper
    clientSecret: process.env.EMAIL_PROCESSOR_CLIENT_SECRET,
    redisDb: Number(process.env.EMAIL_PROCESSOR_REDIS_DB || 2),
    s3Bucket: process.env.EMAIL_PROCESSOR_S3_BUCKET,
    webHookUrl: process.env.EMAIL_PROCESSOR_WEBHOOK_URL,
  },
  freddieMac: {
    sellerServicerNumber: process.env.FREDDIE_MAC_SELLER_SERVICER_NUMBER,
    username: process.env.FREDDIE_MAC_AUS_USERNAME,
    password: process.env.FREDDIE_MAC_AUS_PASSWORD,
    partnerId: '10000035',
    branchId: process.env.FREDDIE_MAC_BRANCH_ID,
  },
  reggora: {
    baseUrl: process.env.REGGORA_BASE_URL,
    apiKey: process.env.REGGORA_API_KEY,
    username: process.env.REGGORA_USERNAME,
    password: process.env.REGGORA_PASSWORD,
  },
  vgs: {
    adminHost: process.env.VGS_ADMIN_API_BASE_URL,
    localMockEnabled: process.env.ENABLE_VGS_MOCK_LOCALLY === 'true',
  },
  newRelic: {
    statsdHost: process.env.NEW_RELIC_STATSD_HOST,
  },
  eventingConfig: {
    accessKeyId: process.env.EVENTING_PROCESSOR_ACCESS_KEY_ID,
    secretAccessKey: process.env.EVENTING_PROCESSOR_SECRET_ACCESS_KEY,
    region: process.env.REGION,
    queueUrl: process.env.EVENTING_PROCESSOR_QUEUE_URL,
    deadLetterUrl: process.env.EVENTING_PROCESSOR_DEAD_LETTER_URL,
  },
  workdayConfig: {
    url: process.env.WORKDAY_API_URL,
    clientId: process.env.WORKDAY_CLIENT_ID,
    clientSecret: process.env.WORKDAY_CLIENT_SECRET,
    refreshToken: process.env.WORKDAY_REFRESH_TOKEN,
  },
  // TODO_FIRST_AMERICAN
  firstAmerican: {
    authUrl: process.env.FIRST_AMERICAN_AUTH_URL,
    baseUrl: process.env.FIRST_AMERICAN_BASE_URL,
    clientId: process.env.FIRST_AMERICAN_CLIENT_ID,
    clientSecret: process.env.FIRST_AMERICAN_CLIENT_SECRET,
    clientCustomerId: process.env.FIRST_AMERICAN_CLIENT_CUSTOMER_ID,
    scope: process.env.FIRST_AMERICAN_SCOPE,
  },
  llamaParse: {
    apiKey: process.env.LLAMA_PARSE_API_KEY,
  },
  sharePoint: {
    tenantId: process.env.SHAREPOINT_TENANT_ID,
    clientId: process.env.SHAREPOINT_CLIENT_ID,
    clientSecret: process.env.SHAREPOINT_CLIENT_SECRET,
    siteId: process.env.SHAREPOINT_SITE_ID,
    driveId: process.env.SHAREPOINT_DRIVE_ID,
    folderId: process.env.SHAREPOINT_FOLDER_ID,
  },
  squeeze: {
    baseUrl: process.env.SQUEEZE_BASE_URL,
    apiKey: process.env.SQUEEZE_API_KEY,
  },
  figure: {
    apiBaseUrl:
      process.env.FIGURE_API_BASE_URL || 'https://api.test.figure.com',
    applicationBaseUrl:
      process.env.FIGURE_APPLICATION_BASE_URL ||
      'https://test.figure.com/leadportal/app/heloc',
    apiKey: process.env.FIGURE_API_KEY,
    goldApiKey: process.env.FIGURE_GOLD_API_KEY,
    conciergeApiKey: process.env.FIGURE_CONCIERGE_API_KEY,
    loanOriginatorUuid:
      process.env.FIGURE_LOAN_ORIGINATOR_UUID ||
      '00000000-0000-0000-0000-000000000000',
    goldLoanOriginatorUuid: process.env.FIGURE_GOLD_LOAN_ORIGINATOR_UUID || '',
    conciergeLoanOriginatorUuid:
      process.env.FIGURE_CONCIERGE_LOAN_ORIGINATOR_UUID || '',
    webhookPrivateKey: process.env.FIGURE_WEBHOOK_PRIVATE_KEY,
    encryptionPublicKey: process.env.FIGURE_ENCRYPTION_PUBLIC_KEY,
  },
  nfty: {
    appApiBaseUrl: process.env.NFTY_APP_API_BASE_URL,
    coreApiBaseUrl: process.env.NFTY_CORE_API_BASE_URL,
    apiEmail: process.env.NFTY_API_EMAIL,
    apiPassword: process.env.NFTY_API_PASSWORD,
    dataApiUrl: process.env.NFTY_DATA_API_BASE_URL,
    dataApiClientId: process.env.NFTY_DATA_API_CLIENT_ID,
    dataApiUsername: process.env.NFTY_DATA_API_USERNAME,
    dataApiPassword: process.env.NFTY_DATA_API_PASSWORD,
  },
  transUnionReport: {
    baseUrl: process.env.TRANSUNION_URL,
    tuClientKey: process.env.TRANSUNION_CLIENT_KEY,
    tuClientKeyPassphrase: process.env.TRANSUNION_CLIENT_KEY_PASSPHRASE,
    tuClientCertificate: process.env.TRANSUNION_CLIENT_CERTIFICATE,
    subscriber: {
      industryCode: process.env.TRANSUNION_INDUSTRY_CODE,
      memberCode: process.env.TRANSUNION_MEMBER_CODE,
      inquirySubscriberPrefixCode:
        process.env.TRANSUNION_INQUIRY_SUBSCRIBER_PREFIX_CODE,
      password: process.env.TRANSUNION_SUBSCRIBER_PASSWORD,
    },
  },
  fannieMaePricingApi: {
    baseUrl: process.env.FANNIE_MAE_PRICING_API_BASE_URL,
    authBaseUrl: process.env.FANNIE_MAE_PRICING_API_AUTH_BASE_URL,
    authClientId: process.env.FANNIE_MAE_PRICING_API_AUTH_CLIENT_ID,
    authClientSecret: process.env.FANNIE_MAE_PRICING_API_AUTH_CLIENT_SECRET,
    apiKey: process.env.FANNIE_MAE_PRICING_API_KEY,
    systemId: process.env.FANNIE_MAE_PRICING_API_SYSTEM_ID,
    password: process.env.FANNIE_MAE_PRICING_API_PASSWORD,
  },
  fannieMaeAdviceSellersApi: {
    baseUrl: process.env.FANNIE_MAE_ADVICE_SELLERS_API_BASE_URL,
    authBaseUrl: process.env.FANNIE_MAE_ADVICE_SELLERS_API_AUTH_BASE_URL,
    authClientId: process.env.FANNIE_MAE_ADVICE_SELLERS_API_AUTH_CLIENT_ID,
    authClientSecret:
      process.env.FANNIE_MAE_ADVICE_SELLERS_API_AUTH_CLIENT_SECRET,
    apiKey: process.env.FANNIE_MAE_ADVICE_SELLERS_API_KEY,
    systemId: process.env.FANNIE_MAE_ADVICE_SELLERS_API_SYSTEM_ID,
    password: process.env.FANNIE_MAE_ADVICE_SELLERS_API_PASSWORD,
  },
  freddieMacPurchaseAdviceApi: {
    baseUrl: process.env.FREDDIE_MAC_PURCHASE_ADVICE_API_BASE_URL,
    authBaseUrl: process.env.FREDDIE_MAC_PURCHASE_ADVICE_API_AUTH_BASE_URL,
    authClientId: process.env.FREDDIE_MAC_PURCHASE_ADVICE_API_AUTH_CLIENT_ID,
    authClientSecret:
      process.env.FREDDIE_MAC_PURCHASE_ADVICE_API_AUTH_CLIENT_SECRET,
    username: process.env.FREDDIE_MAC_PURCHASE_ADVICE_API_USERNAME,
    password: process.env.FREDDIE_MAC_PURCHASE_ADVICE_API_PASSWORD,
    appName: process.env.FREDDIE_MAC_PURCHASE_ADVICE_API_APP_NAME,
  },
  pennyMacPennyPal: {
    baseUrl: process.env.PENNYMAC_PENNYPAL_BASE_URL,
    username: process.env.PENNYMAC_PENNYPAL_USERNAME,
    password: process.env.PENNYMAC_PENNYPAL_PASSWORD,
    apiKey: process.env.PENNYMAC_PENNYPAL_API_KEY,
  },
  raydiant: {
    baseUrl: process.env.RAYDIANT_BASE_URL,
    clientId: process.env.RAYDIANT_CLIENT_ID,
    clientSecret: process.env.RAYDIANT_CLIENT_SECRET,
  },
  serviceMacS3: {
    accessKeyId:
      process.env.SERVICE_MAC_S3_ACCESS_KEY_ID || 'undefined-access-key-id',
    secretAccessKey:
      process.env.SERVICE_MAC_S3_SECRET_ACCESS_KEY ||
      'undefined-secret-access-key',
    region: process.env.REGION || 'undefined-region',
    senderEmail:
      process.env.SERVICE_MAC_SES_SENDER_EMAIL || 'undefined@fake.com',
    complianceEmailAddress:
      process.env.COMPLIANCE_EMAIL_ADDRESS || 'undefined@fake.com',
  },
  annalyS3: {
    accessKeyId: process.env.ANNALY_ACCESS_KEY_ID || 'undefined-access-key-id',
    secretAccessKey:
      process.env.ANNALY_SECRET_ACCESS_KEY || 'undefined-secret-access-key',
    region: process.env.REGION || 'undefined-region',
  },
  rateSheetCreatorOutput: {
    accessKeyId: process.env.RATE_SHEET_CREATOR_OUTPUT_ACCESS_KEY_ID || '',
    secretAccessKey:
      process.env.RATE_SHEET_CREATOR_OUTPUT_SECRET_ACCESS_KEY || '',
    bucketName: process.env.RATE_SHEET_CREATOR_OUTPUT_S3_BUCKET || '',
    region: process.env.REGION || 'us-east-1',
  },
  weaver: {
    url: 'https://weaver.datascience.redventures.io',
    tokenHost: 'https://redventures-prod.auth0.com',
    tokenPath: '/oauth/token',
    clientId: process.env.WEAVER_CLIENT_ID,
    clientSecret: process.env.WEAVER_CLIENT_SECRET,
    production: process.env.APP_ENV === 'prod',
    writeKey: 'wk_1WXMwpLH6pkAsGawbxsU4KAfQQB',
  },
  langfuseClientConfig: {
    langfuseSecretKey: process.env.LANGFUSE_SECRET_KEY,
    langfusePublicKey: process.env.LANGFUSE_PUBLIC_KEY,
    langfuseBaseUrl: process.env.LANGFUSE_BASE_URL,
  },
  partnerApi: {
    baseUrl: process.env.PARTNER_API_BASE_URL || 'http://localhost:5555',
    domain: process.env.PARTNER_API_AUTH0_DOMAIN,
    clientId: process.env.PARTNER_API_AUTH0_CLIENT_ID,
    clientSecret: process.env.PARTNER_API_AUTH0_CLIENT_SECRET,
    audience: process.env.PARTNER_API_AUTH0_AUDIENCE,
  },
  leadRouting: {
    accessKeyId: process.env.LEAD_ROUTING_PROCESSOR_ACCESS_KEY_ID,
    secretAccessKey: process.env.LEAD_ROUTING_PROCESSOR_SECRET_ACCESS_KEY,
    region: process.env.REGION,
    queueUrl: process.env.LEAD_ROUTING_PROCESSOR_QUEUE_URL,
    deadLetterUrl: process.env.LEAD_ROUTING_PROCESSOR_DEAD_LETTER_URL,
  },
  loanMatchProcessor: {
    region: process.env.REGION,
    queueUrl: process.env.LOAN_MATCH_PROCESSOR_QUEUE_URL,
    deadLetterUrl: process.env.LOAN_MATCH_PROCESSOR_DEAD_LETTER_URL,
  },
  plaid: {
    baseUrl:
      process.env.PLAID_BASE_URL ||
      (process.env.PLAID_ENV === 'production'
        ? 'https://production.plaid.com'
        : 'https://sandbox.plaid.com'),
    clientId: process.env.PLAID_CLIENT_ID,
    secret: process.env.PLAID_SECRET,
    env: process.env.PLAID_ENV,
  },
  documentProcessing: {
    orchestratorQueueUrl:
      process.env.DOCUMENT_PROCESSING_ORCHESTRATOR_QUEUE_URL,
    sourceBucket: process.env.DOCUMENT_PROCESSING_SOURCE_BUCKET,
    region: process.env.AWS_REGION || 'us-east-1',
  },
  five9Auth: {
    clientCredentials: {
      clientId: process.env.FIVE9_CLIENT_ID,
      clientSecret: process.env.FIVE9_CLIENT_SECRET,
      signingKey: process.env.FIVE9_SIGNING_KEY,
      tokenExpiresIn: Number(process.env.FIVE9_JWT_EXPIRES_IN) || 3600,
    },
    publicKey: process.env.FIVE9_JWT_PUBLIC_KEY || '',
    issuer: process.env.FIVE9_JWT_ISSUER || '',
    audience: process.env.FIVE9_JWT_AUDIENCE || 'mortgage-pos-api',
  },
  five9Sms: {
    apiUrl: process.env.FIVE9_SMS_API_URL,
    username: process.env.FIVE9_SMS_USERNAME,
    password: process.env.FIVE9_SMS_PASSWORD,
  },
  five9Web2Campaign: {
    apiUrl: process.env.FIVE9_W2C_API_URL,
    username: process.env.FIVE9_W2C_USERNAME,
    password: process.env.FIVE9_W2C_PASSWORD,
    domain: process.env.FIVE9_W2C_DOMAIN || 'Sage Home Loans',
  },
  five9Recordings: {
    s3Bucket: process.env.FIVE9_S3_BUCKET,
    accessKeyId: process.env.FIVE9_S3_ACCESS_KEY_ID,
    secretAccessKey: process.env.FIVE9_S3_SECRET_ACCESS_KEY,
    region: process.env.REGION || 'us-east-1',
  },
  altairConfig: {
    host: process.env.ALTAIR_SFTP_HOST || 'uploads.altairci.com',
    username: process.env.ALTAIR_SFTP_USERNAME || 'SageHomeLoans',
    password: process.env.ALTAIR_SFTP_PASSWORD,
    monitoringDirectory:
      process.env.ALTAIR_SFTP_MONITORING_DIRECTORY || '/catalog_management/',
    suppressionDirectory:
      process.env.ALTAIR_SFTP_SUPPRESSION_DIRECTORY ||
      '/online_suppressions/creditready/',
    dncUploadDirectory:
      process.env.ALTAIR_SFTP_DNC_UPLOAD_DIRECTORY || '/catalog_management/',
    dncProcessedDirectory:
      process.env.ALTAIR_SFTP_DNC_PROCESSED_DIRECTORY ||
      '/catalog_management/catalog_dnc_processed/',
  },
  havenConfig: {
    host: process.env.HAVEN_SFTP_HOST,
    username: process.env.HAVEN_SFTP_USERNAME,
    password: process.env.HAVEN_SFTP_PASSWORD,
    loanLevelOffersDirectory:
      process.env.HAVEN_SFTP_LOAN_LEVEL_OFFERS_DIRECTORY ||
      'upload/loan_level_offers/',
  },
  pulse: {
    authUrl: process.env.PULSE_AUTH_URL,
    brApiUrl: process.env.PULSE_API_URL,
  },
  meilisearch: {
    url: process.env.MEILISEARCH_URL || 'http://localhost:7700',
    masterKey: process.env.MEILISEARCH_MASTER_KEY || '',
    adminKey: process.env.MEILISEARCH_ADMIN_KEY || '',
    searchKey: process.env.MEILISEARCH_SEARCH_KEY || '',
  },
  sendGrid: {
    apiKey: process.env.SENDGRID_API_KEY || '',
    fromEmail: process.env.SENDGRID_FROM_EMAIL || 'noreply@t.sagehomeloans.com',
    fromName: process.env.SENDGRID_FROM_NAME || 'Sage Home Loans',
    webhookVerificationKey: process.env.SENDGRID_WEBHOOK_VERIFICATION_KEY || '',
  },
  sageHermes: {
    apiBaseUrl: process.env.SAGE_HERMES_API_BASE_URL,
    apiServerKey: process.env.SAGE_HERMES_API_SERVER_KEY,
  },
  borrowerPortalUrl: (['prod', 'qa'].includes(process.env.APP_ENV || '')
    ? process.env.UI_BORROWER_PORTAL_URL
    : 'http://localhost:4201') as string,
}
